"use client";
import React, { useState, useRef, useEffect } from "react";

export default function BotChatGPT() {
  // Trạng thái hiển thị popup
  const [isOpen, setIsOpen] = useState(false);

  // Lưu tên người dùng
  const [userName, setUserName] = useState("");

  // Danh sách tin nhắn
  // Mặc định bot sẽ hỏi tên người dùng ngay từ đầu
  const [messages, setMessages] = useState([
    {
      role: "assistant",
      content: "Xin chào! Tôi là trợ lý ảo AI. Hãy nhập tên của bạn (chỉ cần nhập tên):",
    },
  ]);

  // Trạng thái input
  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Tham chiếu để auto-scroll xuống cuối mỗi khi có tin nhắn mới
  const messagesEndRef = useRef(null);
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, isLoading]);

  // Bật/tắt popup
  const handleToggleChat = () => {
    setIsOpen(!isOpen);
  };
  const formatMessage = (message) => {
    return message.replace(/\*\*(.*?)\*\*/g, "$1");
  };
  
  const renderFormattedMessage = (message) => {
    // Nếu là danh sách (dựa vào dấu gạch đầu dòng hoặc số thứ tự)
    if (message.includes("•") || message.includes("1.") || message.includes("-")) {
      return (
        <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
          {message.split("\n").map((line, index) =>
            line.trim() ? (
              <li key={index} style={{ marginBottom: "5px" }}>
                {line.replace(/^(\d+\.|\•|\-)/, "").trim()}
              </li>
            ) : null
          )}
        </ul>
      );
    }
  
    // Nếu là đoạn văn dài
    if (message.length > 100) {
      return message.split("\n\n").map((para, index) => (
        <p key={index} style={{ marginBottom: "10px", lineHeight: "1.6" }}>
          {para}
        </p>
      ));
    }
    // Mặc định trả về đoạn văn bản ngắn
    return <p style={{ lineHeight: "1.6" }}>{message}</p>;
  };
  
  // Gửi tin nhắn
  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!userInput.trim()) return;
  
    // Nếu userName chưa có => đây là bước nhập tên lần đầu
    if (!userName) {
      const name = userInput.trim();
      setUserName(name); // Lưu tên
  
      // Thêm tin nhắn user (tên) + bot chào
      setMessages((prev) => [
        ...prev,
        { role: "user", content: name },
        {
          role: "assistant",
          content: `Xin chào ${name}! Tôi có thể giúp gì cho bạn?`,
        },
      ]);
  
      setUserInput("");
      return;
    }
  

    const fixedPrompt = "Bạn là trợ lý ảo AI, chỉ trả lời câu hỏi liên quan tới vải dân tộc, các dân tộc Việt Nam. Các vấn đề khác không trả lời. Dưới đây là câu hỏi của người dùng: ";
    const userPrompt = userInput.trim();
  
    const newMessages = [
      ...messages,
      { role: "user", content: `${fixedPrompt}\n\n${userPrompt}` }, // Ghép prompt cố định và prompt người dùng
    ];
  
    setMessages((prev) => [...prev, { role: "user", content: userPrompt }]);
    setUserInput("");
    setIsLoading(true);
  
    try {
      const response = await fetch("https://my-api-sage-ten.vercel.app/api/gpt-message-openai", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          model: "gpt-4o-mini",
          messages: newMessages,
          temperature: 0.7,
        }),
      });
  
      if (!response.ok) {
        throw new Error("OpenAI API Error");
      }
  
      const data = await response.json();
      const assistantReply = data.choices?.[0]?.message?.content 
        || "Xin lỗi, tôi không thể trả lời bạn ngay lúc này.";
  
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: assistantReply },
      ]);
    } catch (err) {
      console.error(err);
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: "Đã xảy ra lỗi, vui lòng thử lại." },
      ]);
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <>
      {/* Nút mở/đóng chat dạng tròn, màu Cam */}
      <button
        onClick={handleToggleChat}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          backgroundColor: "#EF7C40",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          border: "none",
          cursor: "pointer",
          zIndex: 9999,
        }}
      >
        {/* Biểu tượng tin nhắn (thay bằng icon tuỳ ý) */}
        <span
          style={{
            display: "block",
            width: "100%",
            height: "100%",
            background: "url('   https://cdn-icons-png.flaticon.com/512/6819/6819656.png ') center/70% no-repeat",
          }}
        ></span>
      </button>

      {/* Popup chat */}
      {isOpen && (
        <div
          style={{
            position: "fixed",
            bottom: "90px",
            right: "30px",
            width: "320px",
            height: "450px",
            backgroundColor: "#F9F5F0", 
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            zIndex: 10000,
          }}
        >
          {/* Header */}
          <div
            style={{
              backgroundColor: "#ec621a",
              color: "#fff",
              padding: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ fontWeight: "bold" }}>Trợ lý ảo AI</div>
            <button
              onClick={handleToggleChat}
              style={{
                background: "none",
                border: "none",
                color: "#fff",
                fontSize: "16px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              ✕
            </button>
          </div>

          {/* Khu vực hiển thị tin nhắn */}
          <div
            style={{
              flex: 1,
              padding: "10px",
              overflowY: "auto",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          >
            {messages.map((msg, index) => {
              const isAssistant = msg.role === "assistant";
              return (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    marginBottom: "10px",
                    justifyContent: isAssistant ? "flex-start" : "flex-end",
                  }}
                >
                  {/* Avatar bot nếu là trợ lý */}
                  {isAssistant && (
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/6819/6819656.png " 
                      alt="assistant avatar"
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        marginRight: "6px",
                        objectFit: "cover",
                      }}
                    />
                  )}
                  <div
                    style={{
                      backgroundColor: isAssistant ? "#ffb31b" : "#EF7C40",
                      color: isAssistant ? "#ffffff" : "#ffffff",
                      padding: "8px 12px",
                      borderRadius: "12px",
                      maxWidth: "75%",
                      wordWrap: "break-word",
                      fontSize: "14px",
                    }}
                  >
                    {renderFormattedMessage(formatMessage(msg.content))}
                  </div>
                </div>
              );
            })}

            {isLoading && (
              <div style={{ textAlign: "left", marginBottom: "10px" }}>
                <div
                  style={{
                    display: "inline-block",
                    backgroundColor: "#ec621a",
                    color: "#ffffff",
                    padding: "8px 12px",
                    borderRadius: "12px",
                    fontSize: "14px",
                  }}
                >
                  Đang trả lời...
                </div>
              </div>
            )}
            {/* Để đảm bảo luôn cuộn xuống cuối */}
            <div ref={messagesEndRef} />
          </div>

          {/* Form nhập tin nhắn */}
          <form
            onSubmit={handleSendMessage}
            style={{
              display: "flex",
              borderTop: "1px solid #ddd",
            }}
          >
            <input
              type="text"
              placeholder="Type the message ..."
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              style={{
                flex: 1,
                border: "none",
                outline: "none",
                padding: "10px",
                fontSize: "14px",
              }}
            />
            <button
              type="submit"
              disabled={isLoading}
              style={{
                backgroundColor: "#ec621a",
                border: "none",
                color: "#fff",
                padding: "0 16px",
                cursor: "pointer",
              }}
            >
              ➤
            </button>
          </form>
        </div>
      )}
    </>
  );
}
